(ns manage.export-display-tag-ocp.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Typography$default" :as Typography]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [manage.export-display-tag-ocp.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui form-field-target-build []
  (let [cm360-option (form/use-cm360-adserver-option)
        has-cm360? (some? cm360-option)
        error-message (when-not has-cm360? "Configure CM360 Adserver to export")]
    ($ form-field
       {:label "Adserver"
        :err-msg error-message}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:adserverId])
                         {:options (if has-cm360? [cm360-option] [])
                          :disabled? true
                          :value (:value cm360-option)})]))))

(defui form-field-target-name []
  (let [multiple-adsets? (use-subscribe [:campaign-tags.page/has-multiple-adsets?])]
    ($ form-field
       {:label "Export name"}
       ($ input (merge (form/use-bind-control [:exportName])
                       {:disabled multiple-adsets?}))
       (when multiple-adsets?
         ($ Typography
            {:variant "caption"
             :sx #js {:color "text.secondary"}}
            "Export name is disabled when tags from multiple adsets are selected")))))

(defui form-field-target-export []
  (let [options (form/use-target-export-options)]
    ($ form-field
       {:label "Adserver seat"}
       (r/as-element
        [dropdown (merge (form/use-bind-control [:adserveraccountconfigurationId])
                         {:options options})]))))

(defui body []
  (let [cm360-option (form/use-cm360-adserver-option)]
    ($ :<>
       ($ form-field-target-build)
       ($ form-field-target-name)
       (when cm360-option
         ($ form-field-target-export)))))

(defui footer []
  (let [config-id (use-subscribe [:form.export-display-tag/value [:adserveraccountconfigurationId]])
        selected-cm360-count (use-subscribe [:campaign-tags.page.selection/selected-cm360-count])
        export-ready? (and config-id (pos? selected-cm360-count))]
    ($ Button {:disabled (not export-ready?)
               :on-click #(rf/dispatch [:form.export-display-tag/bulk-export])
               :variant "contained"}
       (str "Export " selected-cm360-count " Selected Tags"))))

(defocp export-display-tag-ocp :export-display-tag-ocp
  {:elevated-z-index true}
  []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.export-display-tag/init])
                    (fn []
                      (rf/dispatch [:form.export-display-tag/destroy])))
                  [])
  ($ ocp
     {:title "Export Display Tag as Custom Creative"
      :footer ($ footer)}
     ($ body)))
